import React, { useEffect, useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../../images/logo.png";
import android from "../../images/android.png";
import { FaApple, FaTiktok, FaYoutube } from "react-icons/fa";
import { Flex } from "../../styles/global.syles";
import { NavbarContainer } from "./Navbar.styles";

const Navbar = () => {
  const [isFixed, setIsFixed] = useState(false);
  const [shouldShow, setShouldShow] = useState(false);
  const [shownav, setShownav] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  useEffect(() => {
    const sectionIds = ["home", "features", "pricing", "services", "contact-us", "download-app"];

    const handleScroll = () => {
      const scrollPos = window.pageYOffset || document.documentElement.scrollTop;

      // Handle sticky/fixed navbar visibility
      if (scrollPos > 100 && scrollPos <= 300) {
        setIsFixed(true);
        setShouldShow(false);
      } else if (scrollPos > 300) {
        setIsFixed(true);
        setShouldShow(true);
      } else {
        setIsFixed(false);
        setShouldShow(false);
      }

      // Check if user is near the bottom of the page
      if (window.innerHeight + scrollPos >= document.documentElement.scrollHeight - 90) {
        setActiveSection("download-app");
        return;
      }

      // ScrollSpy: dynamically detect which section is in view
      const headerThreshold = 220;
      let currentSection = "home";

      for (let i = 0; i < sectionIds.length; i++) {
        const id = sectionIds[i];
        const el = document.getElementById(id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= headerThreshold) {
            currentSection = id;
          }
        }
      }

      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Prevent background scroll when mobile navigation is open
  useEffect(() => {
    if (shownav) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [shownav]);

  const closeNav = () => setShownav(false);

  const handleNavClick = (e, id) => {
    setActiveSection(id);
    closeNav();
    if (id === "home") {
      if (window.location.pathname === "/") {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  return (
    <NavbarContainer
      isFixed={isFixed}
      shouldShow={shouldShow}
      shownav={shownav}
    >
      {/* Dim backdrop on mobile when menu is active */}
      {shownav && <div className="nav-backdrop" onClick={closeNav} />}

      <div className="container">
        <Flex justify="space-between" className="nav-header-flex">
          {/* logo */}
          <div className="logo">
            <a
              href="/#home"
              onClick={(e) => handleNavClick(e, "home")}
            >
              <img src={logo} alt="Beyond Lottery" width="165" />
            </a>
          </div>

          {/* links with dynamic active indicator */}
          <div className="links">
            <div className={`nav-menu-links ${shownav ? "active" : ""}`}>
              <a
                href="/#home"
                className={`nav-item-link ${activeSection === "home" ? "active" : ""}`}
                onClick={(e) => handleNavClick(e, "home")}
              >
                Home
              </a>
              <a
                href="#features"
                className={`nav-item-link ${activeSection === "features" ? "active" : ""}`}
                onClick={(e) => handleNavClick(e, "features")}
              >
                Features
              </a>
              <a
                href="#pricing"
                className={`nav-item-link ${activeSection === "pricing" ? "active" : ""}`}
                onClick={(e) => handleNavClick(e, "pricing")}
              >
                Pricing
              </a>
              <a
                href="#services"
                className={`nav-item-link ${activeSection === "services" ? "active" : ""}`}
                onClick={(e) => handleNavClick(e, "services")}
              >
                Services
              </a>
              <a
                href="#contact-us"
                className={`nav-item-link ${activeSection === "contact-us" ? "active" : ""}`}
                onClick={(e) => handleNavClick(e, "contact-us")}
              >
                Contact us
              </a>

              <a
                href="#download-app"
                className={`nav-download-item ${activeSection === "download-app" ? "active" : ""}`}
                onClick={(e) => handleNavClick(e, "download-app")}
              >
                <span>Download</span>
                <FaApple className="apple-icon" />
                <img src={android} alt="Android App" className="android-icon" />
              </a>

              <div className="nav-social-wrap">
                <a
                  href="https://www.tiktok.com/@beyondlotto7?_r=1&_t=ZP-9AKXK2mfBvj"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-social-btn tiktok"
                  title="Follow us on TikTok"
                  aria-label="TikTok"
                >
                  <FaTiktok />
                </a>
                <a
                  href="https://youtube.com/@beyondlottery?si=EXAbnJXS3tD2N3o3"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-social-btn youtube"
                  title="Watch us on YouTube"
                  aria-label="YouTube"
                >
                  <FaYoutube />
                </a>
              </div>

              <Link to="/login" onClick={closeNav} className="nav-login-link">
                <button className="nav-login-btn">Login</button>
              </Link>
            </div>

            {/* mobile hamburger toggle */}
            <button
              type="button"
              className="bars"
              onClick={() => setShownav((prevState) => !prevState)}
              aria-label={shownav ? "Close navigation menu" : "Open navigation menu"}
              aria-expanded={shownav}
            >
              {shownav ? <FaTimes /> : <FaBars />}
            </button>
          </div>
        </Flex>
      </div>
    </NavbarContainer>
  );
};

export default Navbar;
